export const allVessels = [
    { key: "To Be Advise", value: "TBA" },
    { key: "OLADUNNI", value: "OLADUNNI" },
    { key: "YEYEMODE", value: "YEYEMODE" },
    { key: "OLASINBO", value: "OLASINBO" },
    { key: "BABA IJEBU", value: "BABA IJEBU" },
    { key: "LAYLA", value: "LAYLA" },
    { key: "ADAMS", value: "ADAMS" },
    { key: "SIMBA", value: "SIMBA" },
    { key: "ZEEZEE", value: "ZEEZEE" },
    { key: "LADY TRISH", value: "LADY TRISH" },
    { key: "JADE", value: "JADE (SHUTTLE VESSEL)"},
  ];
  